module.exports = __webpack_public_path__ + "b28919e5a569b4f962d8110416781ed5.jpg";